export enum USER_PREFERENCE_KEYS {
  DEFAULT_COMPANY_ID = 'defaultCompanyId',
  SIDEBAR_EXPANDED = 'sidebarExpanded'
}

export interface UserPreferences {
  [USER_PREFERENCE_KEYS.DEFAULT_COMPANY_ID]?: string;
  [USER_PREFERENCE_KEYS.SIDEBAR_EXPANDED]?: string;
}

export const USER_PREFERENCES_FEATURE_KEY = 'user_preferences';
export const USER_PREFERENCES_STORAGE_KEY = 'tix_user_preferences';
